export default __webpack_public_path__ + "static/media/services_architecture.a685db5b.png";